import Overview from './overview.vue';
import Detail from '@rebuild/materials/shared/report/DetailIndex.vue';
import MobFull from '@rebuild/materials/shared/report/MobFullIndex.vue';
import MobDetail from '@rebuild/materials/shared/report/MobDetail.vue';


export const componentMap = {
	overview: Overview,
	detail: Detail,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 